module.exports = __webpack_public_path__ + "static/media/santaMonica.3c9e34a9.jpg";